<template>
	
<core-card-foot-date :value="value" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return parseInt((this.isUser) ? this.item.user.play_last : this.item.users.play_last)

		}

	}

}

</script>

<style scoped>

</style>
